import { createApi } from '@reduxjs/toolkit/query/react';
import type { UserSubscriptionType } from '../subscriptions.types';
import { ogBaseQuery } from '../../ogBaseQuery';

export type LbSubscriptionType = {
  subscriptionType: UserSubscriptionType;
};

export const subscriptions = createApi({
  baseQuery: ogBaseQuery(),
  reducerPath: 'subscriptionsOG',
  endpoints: (builder) => ({
    getSubscriptionType: builder.query<
      LbSubscriptionType,
      { userId: string; skipInstitutionCheck?: boolean; cacheBustKey?: string }
    >({
      query: (data) => {
        return {
          url: `users/${data.userId}/getSubscriptionType`,
          method: 'GET',
          params: {
            skipInstitutionCheck: data.skipInstitutionCheck ?? true,
          },
        };
      },
    }),
    validateCoupon: builder.mutation<
      {
        discountAmount?: string;
        amountOff?: boolean;
        valid: boolean;
      },
      {
        code: string;
        currency: string;
        product?: string;
        customerId?: string;
        amount?: number;
        priceId?: string;
      }
    >({
      query: (body) => {
        return {
          url: 'purchases/validateCoupon',
          method: 'POST',
          body,
        };
      },
      transformResponse: (data: { discount?: string; valid: boolean }) => {
        // data.discount could be 35USD or 35%
        if (data.discount !== undefined && !data.discount.includes('%')) {
          return {
            discountAmount: Number.parseFloat(data.discount).toString(),
            amountOff: true,
            valid: data.valid,
          };
        }

        return {
          ...data,
          discountAmount: data.discount,
        };
      },
    }),
  }),
});

export const {
  endpoints: { getSubscriptionType },
  useGetSubscriptionTypeQuery,
  useValidateCouponMutation,
} = subscriptions;
